import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import {
  AnticipatedExpenditureSelectionModel,
  CPLAnticipatedExpenditureClient,
  ReportURLResponseModel,
} from "./api/cplapi/CPLAPI";

export interface IAnticipatedExpenditureReportService {
  resumeProcess(): Promise<AnticipatedExpenditureSelectionModel>;
  resetAnticipatedExpenditureProcess(): Promise<void>;
  previewAnticipatedExpenditureReport(
    reportSelections: AnticipatedExpenditureSelectionModel
  ): Promise<ReportURLResponseModel>;
  acceptAnticipatedExpenditureReport(reportSelections: AnticipatedExpenditureSelectionModel): Promise<void>;
  printAnticipatedExpenditureReport(): Promise<ReportURLResponseModel>;
  emailAnticipatedExpenditureReport(): Promise<ReportURLResponseModel>;
}

@injectable()
export class AnticipatedExpenditureReportService implements IAnticipatedExpenditureReportService {
  @inject(SERVICE_TYPES.CPLAnticipatedExpenditureClient)
  anticipatedExpenditureReportClient!: CPLAnticipatedExpenditureClient;

  async resumeProcess(): Promise<AnticipatedExpenditureSelectionModel> {
    const response = await this.anticipatedExpenditureReportClient.resumeProcess();
    return response;
  }

  async resetAnticipatedExpenditureProcess(): Promise<void> {
    await this.anticipatedExpenditureReportClient.resetAnticipatedExpenditureProcess();
  }

  async previewAnticipatedExpenditureReport(
    reportSelections: AnticipatedExpenditureSelectionModel
  ): Promise<ReportURLResponseModel> {
    const response =
      await this.anticipatedExpenditureReportClient.previewAnticipatedExpenditureReport(reportSelections);
    return response;
  }

  async acceptAnticipatedExpenditureReport(reportSelections: AnticipatedExpenditureSelectionModel): Promise<void> {
    await this.anticipatedExpenditureReportClient.acceptAnticipatedExpenditureReportBackgroundProcess(reportSelections);
  }

  async printAnticipatedExpenditureReport(): Promise<ReportURLResponseModel> {
    const response = await this.anticipatedExpenditureReportClient.printAnticipatedExpenditureReport();
    return response;
  }

  async emailAnticipatedExpenditureReport(): Promise<ReportURLResponseModel> {
    const response = await this.anticipatedExpenditureReportClient.emailAnticipatedExpenditureReport();
    return response;
  }
}
